import authService from './auth.service';
import axios from 'axios';
import router from '@/router';
import { v4 as uuidv4 } from 'uuid';

export const USERS_API_HOST = process.env.VUE_APP_USERS_API_HOST;
export const INTERVENERS_API_HOST = process.env.VUE_APP_INTERVENERS_API_HOST;
export const ACCOUNTS_API_HOST = process.env.VUE_APP_ACCOUNTS_API_HOST;
export const ISSUES_API_HOST = process.env.VUE_APP_ISSUES_API_HOST;

const responseHandler = response => {
    if (!response.data) {
        throw new Error('Response has no expected structure');
    }
    return response.data;
};

const errorResponseHandler = async errorResponse => {
    // By default: error setting up request
    console.warn('errorResponse');
    console.warn(errorResponse);
    console.warn(errorResponse.response);
    if (errorResponse.response && errorResponse.response.status === 401) {
        router.push('/login');
        const err = new Error();
        err.name = 'Error 401';
        err.message = 'No autorizado';
        throw err;
    }

    if (errorResponse.response && errorResponse.response.status === 404) {
        console.warn('Error 404');
        const err = new Error();
        err.name = 'Error 404';
        err.code = '404';
        err.message = 'No encontrado';
        throw err;
    }

    if (errorResponse.response && errorResponse.response.status === 400) {
        const err = new Error();
        err.name = 'Error 400';
        err.code = '400';
        err.message = errorResponse.response.data.result.info;
        throw err;
    }

    const err = new Error(errorResponse.response);
    err.name =
        errorResponse.response && errorResponse.response.status
            ? `${errorResponse.response.status}`
            : 'HTTP Error';
    if (
        errorResponse.response &&
        errorResponse.response.data &&
        errorResponse.response.data.result
    ) {
        err.message = errorResponse.response.data.result.info;
        if (
            errorResponse.response.data.result.errors &&
            errorResponse.response.data.result.errors[0]
        ) {
            err.message = `${errorResponse.response.data.result.errors[0].message}`;
        }
    } else {
        err.message = 'No response was received';
    }
    throw err;
};

/**
 * @override
 */
class ApiService {
    /**
     * Crea configuración base de la conexión
     * @return {*} Coniguración de la conexión
     */
    config() {
        const token = localStorage.getItem('PACOAT');
        const barearToken = token ? `Bearer ${token}` : null;

        const cfg = {
            baseURL: process.env.USERS_API_HOST,
            withCredentials: false,
            headers: {
                Accept: '*/*',
                'Content-Type': 'application/json',
                Authorization: barearToken,
                'X-Request-Id': uuidv4()
            }
        };

        return cfg;
    }

    /**
     * @override
     */
    constructor(baseConfig = undefined) {
        this.connection = axios.create(Object.assign(this.config(), baseConfig));
        this.connection.interceptors.request.use(
            authService.authorizationInterceptor,
            authService.authorizationInterceptorOnError
        );
        this.connection.interceptors.response.use(responseHandler, errorResponseHandler);
    }
    /**
     * @override
     */
    getList(url, config = {}) {
        if (!config.params) {
            config.params = {};
        }
        if (!config.params['$limit']) {
            config.params['$limit'] = 25;
        }
        if (config.params['$limit'] === 'null') {
            delete config.params['$limit'];
        }
        if (!config.params['$offset']) {
            config.params['$offset'] = 0;
        }
        if (config.params['$offset'] === 'null') {
            delete config.params['$offset'];
        }
        if (config.params['$filter'] === 'null') {
            delete config.params['$filter'];
        }
        if (config.params['$filter']) {
            config.params['$filter'] = window.btoa(
                unescape(encodeURIComponent(config.params['$filter']))
            );
        }
        return this.connection.get(url, config);
    }

    /**
     * @override
     */
    getDownload(url, config = {}, payload) {
        if (!config.params) {
            config.params = {};
        }
        if (!config.params['$limit']) {
            config.params['$limit'] = 25;
        }
        if (!config.params['$offset']) {
            config.params['$offset'] = 0;
        }
        if (config.params['$filter'] === 'null') {
            delete config.params['$filter'];
        }
        if (config.params['$filter']) {
            config.params['$filter'] = window.btoa(
                unescape(encodeURIComponent(config.params['$filter']))
            );
        }
        if (!config.params['$format']) {
            config.params['$format'] = 'CSV';
        }
        return this.connection.post(url, payload, config);
    }

    /**
     * @override
     */
    get(url, config = {}) {
        return this.connection.get(url, config);
    }

    /**
     * @override
     */
    delete(url, config = {}) {
        return this.connection.delete(url, config);
    }

    /**
     * @override
     */
    post(url, payload, config = {}) {
        return this.connection.post(url, payload, config);
    }

    /**
     * @override
     */
    put(url, payload, config = {}) {
        return this.connection.put(url, payload, config);
    }

    /**
     * @override
     */
    patch(url, payload, config = {}) {
        return this.connection.patch(url, payload, config);
    }
}

export default ApiService;
